export default __webpack_public_path__ + "static/media/padel.b6f19910.jpg";